import ShepherdJS from 'shepherd.js';
import { offset } from '@floating-ui/dom';
import {
  buttons,
  disableStepFocus,
  // disableBodyScroll,
  // enableBodyScroll,
} from './tour-utils';

export const STEP_ID_ADD_IMAGE = 'step-add-image';
export const STEP_ID_IMAGE_SEARCH = 'step-image-search';
export const STEP_ID_SELECT_FOCUS_TRACK = 'step-select-focus-track';
export const STEP_ID_CLICK_FOCUS_TRACK = 'step-click-focus-track';
export const STEP_ID_OPEN_DRAWER = 'step-open-drawer';
export const STEP_ID_MORE_OPTIONS = 'step-more-options';
export const STEP_ID_CLICK_SHARE = 'step-click-share';
export const STEP_ID_SHARE_SWITCH = 'step-share-switch';
export const STEP_ID_SHARE_CLOSE = 'step-share-close';
export const STEP_ID_CHECK_WRITER_PROFILE = 'step-check-writer-profile';
export const STEP_ID_SELECT_YOUR_PROFILE = 'step-select-your-profile';

// let disableBodyScrollTimeout = null;

export const createTour = () => {
  const tour = new ShepherdJS.Tour({
    useModalOverlay: true,
    exitOnEsc: false,
    keyboardNavigation: false,
    defaultStepOptions: {
      classes: 'shadow-md bg-purple-dark',
      scrollTo: true,
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 16, crossAxis: 0 })],
      },
      // beforeShowPromise: () => {
      //   console.log('debug', 'tour beforeShowPromise');
      //   return new Promise((resolve) => {
      //     clearTimeout(disableBodyScrollTimeout);
      //     enableBodyScroll();
      //     console.log('debug', 'tour beforeShowPromise', 'completed');
      //     resolve();
      //   });
      // },
      // when: {
      //   show: () => {
      //     const currentStep = tour.getCurrentStep();
      //     if (
      //       ['step-format-h1', 'step-write-words', STEP_ID_ADD_IMAGE].includes(
      //         currentStep.id
      //       )
      //     ) {
      //       return;
      //     }

      //     console.log('debug', 'tour when.show', { currentStep });

      //     // on ios devices, just simply enabling body scroll lock on tour.active as Shepherd.js docs suggest won't work
      //     // so we need to enable body scroll lock before showing a step so the scrollIntoView call can work
      //     // but then we would like to disable body scroll lock again, but there is no way to know when the scrolling has finished
      //     // so we need to use a timeout to disable body scroll lock after a short delay
      //     disableBodyScrollTimeout = setTimeout(() => {
      //       disableBodyScroll(currentStep.el);
      //     }, 100);

      //     console.log(
      //       'debug',
      //       'tour when.show',
      //       'disableBodyScroll timeout set'
      //     );
      //   },
      // },
    },
  });

  tour.addStep({
    id: 'step-intro',
    title: 'Your document editor',
    text: `This is where the magic happens. Click Next to get started.`,
    classes: 'tip-common',
    buttons: buttons(tour),
  });

  addTitleStep(tour, 'desktop');

  const formatH1Step = tour.addStep({
    id: 'step-format-h1',
    // title: 'Format the text',
    text: `Highlight "1. Mrs. Whatsit" to bring up the formatting options. Choose "H1."`,
    classes: 'tip-common',
    buttons: buttons(tour),
    modalOverlayOpeningPadding: 32,
    arrow: false,
  });
  disableStepFocus(formatH1Step);
  formatH1Step.on('show', () => {
    // hide Shepherd.js overlay - the cutout is buggy on mobile with the virtual keyboard, the positioning is wrong
    // we have the overlay from the modal anyway
    document.querySelector('.shepherd-modal-overlay-container').style.display =
      'none';
  });

  const writeWordsStep = tour.addStep({
    id: 'step-write-words',
    // title: 'Start writing',
    text: `Let’s write the famous first words of this classic book. Click inside the editor on the line after the heading you just created. Type, “It was a dark and stormy night.”`,
    classes: 'tip-common',
    buttons: buttons(tour),
    modalOverlayOpeningPadding: 32,
    arrow: false,
  });
  disableStepFocus(writeWordsStep);

  const addImageStep = tour.addStep({
    id: STEP_ID_ADD_IMAGE,
    // title: 'Add Image',
    text: `Now hit enter/return after the sentence you just wrote to create a new line below it. Icons will appear to the right of your new empty line. Simply click the first icon in the row to add a new image.`,
    classes: 'tip-common',
    buttons: [buttons(tour)[1]],
    modalOverlayOpeningPadding: 32,
    arrow: false,
  });
  disableStepFocus(addImageStep);
  addImageStep.on('hide', () => {
    document.querySelector('.shepherd-modal-overlay-container').style.display =
      'block';
  });

  const imageSearchStep = tour.addStep({
    id: STEP_ID_IMAGE_SEARCH,
    text: 'Go ahead and search for "dark and stormy", select an image, scroll down to the bottom of the modal and click "save".',
    classes: 'tip-common',
    attachTo: {
      element: '.tour-unsplashSearchInput',
      on: 'top',
    },
    extraHighlights: ['.tour-imageModal'],
    buttons: [buttons(tour)[1]],
  });
  disableStepFocus(imageSearchStep);

  addFocusTrackStep(tour, 'desktop');

  tour.addStep({
    id: STEP_ID_CLICK_FOCUS_TRACK,
    title: 'Select a focus track',
    text: `Let's get in the zone. Click the headphone icon and choose "Peaceful Thunder."`,
    classes: 'tip-common',
    attachTo: {
      element: 'li.peaceful-thunder',
      on: 'auto',
    },
    buttons: [buttons(tour)[1]],
  });

  addMoreOptionsStep(tour, 'desktop');

  tour.addStep({
    id: STEP_ID_CLICK_SHARE,
    text: 'To start, try clicking share',
    classes: 'tip-common',
    attachTo: {
      element: '.tour-share',
      on: 'auto',
    },
    buttons: [buttons(tour)[1]],
  });

  tour.addStep({
    id: STEP_ID_SHARE_SWITCH,
    title: 'Sharing is easy',
    text: 'Toggle the switch to enable sharing',
    classes: 'tip-common',
    attachTo: {
      element: '.tour-shareSwitch',
      on: 'auto',
    },
    buttons: [buttons(tour)[1]],
  });

  tour.addStep({
    id: STEP_ID_SHARE_CLOSE,
    title: 'Click or copy',
    text: 'From here you can directly go to the shared document or copy the link. For now go ahead and click "close"',
    classes: 'tip-common',
    attachTo: {
      element: '.tour-shareClose',
      on: 'auto',
    },
    buttons: [buttons(tour)[1]],
  });

  tour.addStep({
    id: 'step-looks-great',
    title: 'Looks great!',
    text: "Next let's create an online portfolio to show off your work in just a few minutes. Click next to get started!",
    classes: 'tip-common',
    buttons: buttons(tour),
  });

  tour.addStep({
    id: STEP_ID_CHECK_WRITER_PROFILE,
    title: "Check out your Writer's Profile",
    text: "Let's take a peek at your profile. Click here to get started.",
    classes: 'tip-common',
    attachTo: {
      element: '.tour-portfolio',
      on: 'auto',
    },
    buttons: [buttons(tour)[1]],
  });

  tour.addStep({
    id: STEP_ID_SELECT_YOUR_PROFILE,
    text: 'Now select "Your Profile"',
    classes: 'tip-common',
    attachTo: {
      element: '.tour-profile',
      on: 'auto',
    },
    buttons: [buttons(tour)[1]],
  });

  console.log(
    'debug',
    'tour',
    'tour created',
    { tour },
    'steps sequence',
    tour.steps.map((step) => step.id).join(' -> ')
  );

  return tour;
};

export const updateTourForDesktop = (tour) => {
  removeTitleStep(tour);
  removeDrawerStep(tour);
  removeFocusTrackStep(tour);
  removeMoreOptionsStep(tour);

  addTitleStep(tour, 'desktop');
  addFocusTrackStep(tour, 'desktop');
  addMoreOptionsStep(tour, 'desktop');

  console.log(
    'debug',
    'tour',
    'updated tour for desktop',
    { tour },
    'new step sequence',
    tour.steps.map((step) => step.id).join(' -> ')
  );
};

export const updateTourForMobile = (tour) => {
  removeTitleStep(tour);
  removeDrawerStep(tour);
  removeFocusTrackStep(tour);
  removeMoreOptionsStep(tour);

  addTitleStep(tour, 'mobile');
  addDrawerStep(tour);
  addFocusTrackStep(tour, 'mobile');
  addMoreOptionsStep(tour, 'mobile');

  console.log(
    'debug',
    'tour',
    'updated tour for mobile',
    { tour },
    'steps sequence',
    tour.steps.map((step) => step.id).join(' -> ')
  );
};

const addTitleStep = (tour, device = 'desktop') => {
  const titleStep = tour.addStep(
    {
      id: `step-title`,
      text: `We created a document for you to get started. Let's call it "A Wrinkle In Time." Click where it says "Untitled" and type the title.`,
      classes: 'tip-common',
      attachTo: {
        element: `.guided-tour__title-input--${device}`,
        on: 'bottom-start',
      },
      buttons: buttons(tour),
    },
    1
  );
  disableStepFocus(titleStep);
};

const removeTitleStep = (tour) => {
  tour.removeStep(`step-title`);
};

const addDrawerStep = (tour) => {
  tour.addStep(
    {
      id: STEP_ID_OPEN_DRAWER,
      text: `Now click this button to open the sidebar and get access to a variety of the editor features.`,
      classes: 'tip-common',
      attachTo: {
        element: `.tour-drawer`,
        on: 'auto',
      },
      buttons: [buttons(tour)[1]],
    },
    6
  );
};

const removeDrawerStep = (tour) => {
  tour.removeStep(STEP_ID_OPEN_DRAWER);
};

const addFocusTrackStep = (tour, device = 'desktop') => {
  tour.addStep(
    {
      id: STEP_ID_SELECT_FOCUS_TRACK,
      title: 'Select a focus track',
      text: `Let's get in the zone. Click the headphone icon and choose "Peaceful Thunder."`,
      classes: 'tip-common',
      attachTo: {
        element:
          device === 'mobile'
            ? '.tour-audio-drawer .tour-audio'
            : '.tour-audio',
        on: 'auto',
      },
      buttons: [buttons(tour)[1]],
    },
    device === 'mobile' ? 7 : 6
  );
};

const removeFocusTrackStep = (tour) => {
  tour.removeStep(STEP_ID_SELECT_FOCUS_TRACK);
};

const addMoreOptionsStep = (tour, device = 'desktop') => {
  tour.addStep(
    {
      id: STEP_ID_MORE_OPTIONS,
      title: 'Share your work',
      text: 'Click here to see options for publishing, sharing, or downloading your doc.',
      classes: 'tip-common',
      attachTo: {
        element:
          device === 'mobile'
            ? '.tour-moreOptions-drawer'
            : '.tour-moreOptions',
        on: 'auto',
      },
      buttons: [buttons(tour)[1]],
    },
    device === 'mobile' ? 9 : 8
  );
};

const removeMoreOptionsStep = (tour) => {
  tour.removeStep(STEP_ID_MORE_OPTIONS);
};
